import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useIsMobileDimension } from '@beef/ui-kit/hooks';
import { BackCallPopup } from "../BackCallPopup";
var DEFAULT_TIMEOUT = 40000;
var LeaveYourPhonePopupWidget = function LeaveYourPhonePopupWidget(_ref) {
  var backCallPopupData = _ref.backCallPopupData,
    selfCallingPopupData = _ref.selfCallingPopupData,
    redesign = _ref.redesign,
    showActionBar = _ref.showActionBar,
    isConvergent = _ref.isConvergent,
    isPersonalVerificationCheckboxEnable = _ref.isPersonalVerificationCheckboxEnable;
  var isMobile = useIsMobileDimension();
  var setPopupTimeout = selfCallingPopupData.setPopupTimeout;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showPopup = _useState2[0],
    setShowPopup = _useState2[1];
  var _useState3 = useState(function () {
      if (typeof setPopupTimeout !== 'number') {
        return DEFAULT_TIMEOUT;
      }
      return setPopupTimeout < 1000 ? setPopupTimeout * 1000 : setPopupTimeout;
    }),
    _useState4 = _slicedToArray(_useState3, 1),
    popupTimer = _useState4[0];
  var handlePopupVisibility = function handlePopupVisibility() {
    return setShowPopup(!showPopup);
  };
  var getFlagFromSessionStorage = function getFlagFromSessionStorage() {
    return sessionStorage.getItem('backCallPopupIsShown');
  };
  var mouseMoveEventHandler = function mouseMoveEventHandler(evt) {
    if (getFlagFromSessionStorage()) {
      document.removeEventListener('mousemove', mouseMoveEventHandler);
      return;
    }
    if (evt.clientY < 10) {
      handlePopupVisibility();
    }
  };
  var setDesktopPopup = function setDesktopPopup() {
    setTimeout(function () {
      document.addEventListener('mousemove', mouseMoveEventHandler);
    }, popupTimer);
  };
  var setMobilePopup = function setMobilePopup() {
    setTimeout(function () {
      if (getFlagFromSessionStorage()) return;
      handlePopupVisibility();
    }, DEFAULT_TIMEOUT);
  };
  useEffect(function () {
    if (isMobile) {
      setMobilePopup();
    } else {
      setDesktopPopup();
    }
  }, [isMobile]);
  useEffect(function () {
    var invokePopupImmediately = new URLSearchParams(window.location.search).get('callback');
    if (invokePopupImmediately) {
      handlePopupVisibility();
      var newUrl = window.location.href.replace(window.location.search, '');
      window.history.replaceState({}, '', newUrl);
    }
  }, []);
  return showPopup ? /*#__PURE__*/React.createElement(BackCallPopup, {
    data: backCallPopupData,
    isConvergent: isConvergent,
    isOpen: showPopup,
    isPersonalVerificationCheckboxEnable: isPersonalVerificationCheckboxEnable,
    onClose: handlePopupVisibility,
    redesign: redesign,
    showAbbreviatedPopup: showPopup,
    showActionBar: showActionBar,
    showCaptcha: backCallPopupData.showCaptcha,
    "data-t-id": "legacy-LeaveYourPhonePopupWidget"
  }) : null;
};
LeaveYourPhonePopupWidget.propTypes = process.env.NODE_ENV !== "production" ? {
  showActionBar: PropTypes.bool,
  backCallPopupData: PropTypes.shape({
    showCaptcha: PropTypes.bool
  }),
  selfCallingPopupData: PropTypes.shape({
    setPopupTimeout: PropTypes.number
  }),
  redesign: PropTypes.bool,
  isConvergent: PropTypes.bool,
  isPersonalVerificationCheckboxEnable: PropTypes.bool
} : {};
export default LeaveYourPhonePopupWidget;